import React from "react";
import { useTranslation } from "react-i18next";

import { FilterMenu } from "@common/filterMenu";
import { HelpTooltip } from "@common/helpTooltip";
import { GranularitySelector } from "./granularitySelector";
import { YearNavigation } from "./yearNavigation";
import { SortDropdown } from "./sortDropdown";
import { Props } from "./types";
import styles from "./styles.scss";

function Toolbar(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.toolbar}>
      <SortDropdown sort={props.sort} setSort={props.setSort} />
      <div className={styles.filter}>
        <p className={styles.title}>{t("occupancyPage.toolbar.filterTitle")}</p>
        <FilterMenu
          filter={props.filter}
          setFilter={props.setFilter}
          placeholder={t("occupancyPage.toolbar.filterPlaceholder")}
          views={[
            "resources",
            "resourceTags",
            "groups",
            "roles",
            "zones",
            "projects",
            "projectsTags",
            "projectsElementsTags",
            "projectPortfolios",
            "projectStatuses",
          ]}
          openedViews={["resources"]}
        />
      </div>
      <YearNavigation year={props.year} setYear={props.setYear} />
      <HelpTooltip
        titleKey="occupancyPage.toolbar.helpTitle"
        bodyKey="occupancyPage.toolbar.help"
      />
      <GranularitySelector
        granularity={props.granularity}
        setGranularity={props.setGranularity}
      />
    </div>
  );
}

export { Toolbar };
